exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Page_page__33Xdn{margin-bottom:0}@media only screen and (max-width:719px){.apcComparison .container.Page_page__33Xdn,.Page_page__33Xdn{padding-top:10px}.se-breadcrumbs+.Page_page__33Xdn{padding-top:15px}}@media only screen and (min-width:720px){.Page_page__33Xdn{padding-top:30px}.Page_page__33Xdn.Page_noPadding__iR1Q9{padding-top:0}.se-recommendations-header+.Page_page__33Xdn{padding-top:30px}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"page": "Page_page__33Xdn",
	"noPadding": "Page_noPadding__iR1Q9"
};